RivalIQ.apps.Insights.module('utils', function (utils, App, Backbone, Marionette, $, _, s) {

    'use strict';

    utils.validCurationOptions = [
        'searchTerm',
        'companyId',
        'mediaTypeFilter',
        'tweetTypeFilter',
        'instanceId',
        'postTagIds',
        'postTagConjunction',
        'postTagExclude',
        'mustHavePostTagIds'
    ];

    utils.withFacebookExportNames = function (widgetConfig, options) {
        const exportConfig = widgetConfig.export || {};

        if (widgetConfig.header && widgetConfig.header.title) {
            const title = _.result(widgetConfig.header, 'title');
            widgetConfig.header.exportTitle = ['Facebook Insights:', title].join(' ');

            exportConfig.filename = RivalIQ.export.filename.base({
                title: title,
                companyId: options.companyId
            });
        }

        return _.extend(widgetConfig, {
            export: exportConfig
        });
    };

    utils.getDefaultPostColumns = function () {

        return [
            {
                name: 'published_at',
                property: 'published_at'
            },
            {
                name: 'captured_at',
                property: 'captured_at'
            }
        ];
    };

    utils.getDefaultPostColumnsForPostsModal = function (dashboardModel) {

        let postMetrics = null;

        switch (dashboardModel.getProp('source')) {

            case RivalIQ.enums.sources.FACEBOOK_INSIGHTS:
                postMetrics = [
                    'engagement_total',
                    'impressions',
                    'engagement_rate_by_impression'
                ];
                break;

            case RivalIQ.enums.sources.INSTAGRAM_INSIGHTS:
                if (RivalIQ.apps.Insights.utils.hasInstagramPaidEngagement(dashboardModel)) {
                    postMetrics = [
                        'engagement_total',
                        'impressions',
                        'engagement_rate_by_impression'
                    ];
                } else {
                    postMetrics = [
                        'organic_engagement_total',
                        'organic_impressions',
                        'organic_engagement_rate_by_impression'
                    ];
                }
                break;

            case RivalIQ.enums.sources.TWITTER_INSIGHTS:
                postMetrics = [
                    'engagement_total',
                    'impressions',
                    'engagement_rate_by_impression'
                ];
                break;

            case RivalIQ.enums.sources.LINKEDIN:
                postMetrics = [
                    'engagement_total',
                    'impressions',
                    'engagement_rate_by_presence_reach'
                ];
                break;
            default:
                throw new Error(` default post columns for Post Modal unknown source ${dashboardModel.getProp('source')}`);
        }

        return postMetrics;

    };

    utils.constructInsightsCompanyDataFetch = function (props) {
        const options = {
            granularity: RivalIQ.enums.dataGranularity.trends
        };

        return RivalIQ.data.companyData.fetch(props, options);
    };

    utils.getUnderReportingAlert = function (curation, description) {
        if (curation.isFacebookUnderReporting) {
            return {
                title: RivalIQ.strings.facebook_insights_post_detail_data_warning_title,
                description: description
            };
        } else {
            return null;
        }
    };

    function constructAppliedFiltersText(searchTerm, mediaTypeFilter) {
        const appliedFilters = [];
        if (searchTerm.length) {
            appliedFilters.push(`query: ${searchTerm}`);
        }

        if (mediaTypeFilter.length) {
            appliedFilters.push(`type: ${s.capitalize(mediaTypeFilter)}`);
        }

        if (appliedFilters.length) {
            return [' (', appliedFilters.join(', '), ')'].join('');
        } else {
            return '';
        }
    }

    /**
     * generates a function for the export title which will include the searchTerm
     */
    utils.insightsExportTitle = function () {
        const me = this;
        const title = _.result(me, 'title');

        if (!me.isFocus() || me.isExportingPPT()) { // PPT export uses a subtitle to show searchTerm
            return title;
        }

        const searchTerm = s.trim(me.getProp('searchTerm'));
        const postTypeFilter = s.trim(me.getProp('type'));
        const company = RivalIQ.state.landscape.getCompanyById(me.getProp('companyId'));

        const source = me.getProp('source');
        const channelName = RivalIQ.data.channels.get(RivalIQ.enums.sourceDetails[source].channel).get('name');

        const appName = (_.includes([RivalIQ.enums.sources.LINKEDIN, RivalIQ.enums.sources.TWITTER_INSIGHTS], source) ? 'Analytics:' : 'Insights:');

        return [
            channelName,
            appName,
            company.get('name'),
            title,
            constructAppliedFiltersText(searchTerm, postTypeFilter)
        ].join(' ');
    };

    utils.insightsExportSubtitle = function () {
        const me = this;

        if (!me.isFocus()) {
            return;
        }

        let timePeriod = me.getProp('timePeriod');
        if (me.getProp('timePeriodType')) {
            timePeriod = RivalIQ.state.timePeriods.getByType(me.getProp('timePeriodType'));
        }

        const timezone = RivalIQ.state.landscape.get('timezone');
        return RivalIQ.utils.timePeriod.getTimePeriodDisplayString(timePeriod, null, timezone);
    };

    utils.insightsPptSubtitle = function () {
        const me = this;

        const timePeriod = me.getProp('timePeriod');
        const searchTerm = s.trim(me.getProp('searchTerm'));
        const mediaTypeFilter = s.trim(me.getProp('mediaTypeFilter'));

        const timezone = RivalIQ.state.landscape.get('timezone');
        const timePeriodStr = RivalIQ.utils.timePeriod.getTimePeriodDisplayString(timePeriod, null, timezone);

        return [timePeriodStr, constructAppliedFiltersText(searchTerm, mediaTypeFilter)].join(' ');
    };

    utils.createInsightsMetric = function (objectType, props) {

        const dimensions = (props.companyId ?
            ['timeAnalysisMode', objectType, 'channel', 'companyId'] :
            ['timeAnalysisMode', objectType, 'channel']);

        const metricAttrs = _.extend({
            dimensions: dimensions,
            timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD
        }, props);

        if (!metricAttrs.channel) {
            metricAttrs.channel = RivalIQ.enums.sourceDetails[props.source].channel;
        }

        if (!props.useUniversalMetricsApi) {
            switch (objectType) {
                case RivalIQ.enums.insightsObjectType.story:
                    metricAttrs.concept = RivalIQ.metrics.descriptions.INSTAGRAM_STORIES.id;
                    break;

                case RivalIQ.enums.insightsObjectType.storyDay:
                    metricAttrs.concept = RivalIQ.metrics.descriptions.INSTAGRAM_STORY_DAYS.id;
                    break;

                case RivalIQ.enums.insightsObjectType.post:
                    metricAttrs.concept = RivalIQ.metrics.descriptions.INSIGHTS_POSTS_SEARCH.id;
                    break;
                default:
                    throw new Error(`unknown insight objectType ${objectType}`);
            }
        } else {
            metricAttrs.useUniversalMetricsApi = true;
        }

        return metricAttrs;
    };

    utils.buildStoryDayCompareMetric = function (metric) {
        // Each compare metric for story day is looking at similar a metric for all of the main time period.
        return metric.build({
            storyDay: undefined,
            dimensions: ['timeAnalysisMode', 'channel', 'companyId'],
            displayString: RivalIQ.strings.instagram_insights_story_day_compare_metric_display_string
        }, {
            clobberDimensions: true
        });
    };

    utils.isLoadingInstagramPromotedPosts = function (widget) {
        // NOTE: this fcn is only used in instagram widgets filters to determine if we're
        // still pulling paid posts. since fb is throwing permission errors for some IG
        // campaigns, don't restrict rendering the data we do have. see #30784
        return false;
    };

    utils.hasInstagramBusinessAccount = function (dashboardModel) {
        const presence = _.get(dashboardModel, ['curation', 'presence']);
        if (!presence) {
            return false;
        }

        const handle = _.get(presence.get('sources'), [RivalIQ.enums.sources.INSTAGRAM_INSIGHTS, 'handle']);
        return _.some(dashboardModel.curation.activeFacebookAdAccounts, function (activeFacebookAdAccount) {
            return _.some(activeFacebookAdAccount.promote_pages, function (promotePage) {
                const username = _.get(promotePage, ['instagram_business_account', 'username']);
                return (username === handle);
            });
        });
    };

    utils.hasInstagramPaidEngagement = function (dashboardModel) {
        if (!dashboardModel) {
            return false;
        }

        const curation = _.result(dashboardModel, 'getCuration') || _.result(dashboardModel.dashboardModel, 'getCuration');
        let presences;
        if (!curation) {
            presences = [dashboardModel.presence];
        } else {
            let widgetInstanceState;
            if (dashboardModel.getWidgetInstanceState) {
                widgetInstanceState = dashboardModel.getWidgetInstanceState(dashboardModel.getProp('focusWidgetInstanceId'));
            } else if (dashboardModel.dashboardModel && dashboardModel.dashboardModel.getWidgetInstanceState) {
                widgetInstanceState = dashboardModel.dashboardModel.getWidgetInstanceState();
            }

            if (widgetInstanceState) {
                if (_.get(dashboardModel, ['curation', 'widgetId']) === RivalIQ.enums.widgetTypes.MEDIA_WIDGET) {
                    presences = _.compact(_.values(_.get(widgetInstanceState, ['instagramCompanies'])));
                } else {
                    presences = _.compact([_.get(widgetInstanceState, ['instagramPresence'])]);
                }
            }

            if (_.isEmpty(presences)) {
                presences = _.compact([_.get(curation, ['presence'])]);
            }
        }

        if (_.isEmpty(presences)) {
            return false;
        }

        const haveAdsToken = _.some(presences, presence => {
            const sources = presence.sources || presence.get('sources');
            const adsReadGrant = _.get(sources, [
                RivalIQ.enums.sources.INSTAGRAM_INSIGHTS,
                '_tokens',
                0,
                'grants',
                'ads_read'
            ]);

            return (adsReadGrant === 'granted');
        });
        return haveAdsToken;
    };

    utils.getWidgetDefinitions = function (props, isFocus) {
        const detailViewMetrics = props.detail_view_metrics;
        let definitions = props[`${props.objectType}_metrics`] || [];
        if (detailViewMetrics && isFocus) {
            definitions = definitions.concat(detailViewMetrics);
        }
        return definitions;
    };

    utils.buildInsightsTableMetrics = function (dashboardModel, initialDefinition, props) {
        dashboardModel.metric = new RivalIQ.models.MetricDefinition(_.clone(dashboardModel.baseMetric));

        const isFocus = dashboardModel.isExporting() ? dashboardModel.getProp('isFocus') : (dashboardModel.isFocus() || dashboardModel.curation.isFocus());

        let definitions = utils.getWidgetDefinitions(props, isFocus);
        definitions = _.compact([initialDefinition]).concat(definitions);

        const built = _.map(definitions, function (config) {
            if (_.isString(config)) {
                config = {
                    property: config
                };
            }

            config.dimensions = [props.analysisProperty];

            const definition = (new RivalIQ.models.MetricDefinition(config)).toJSON();
            return dashboardModel.metric.build(_.defaults(definition, props));
        });

        dashboardModel.metrics = built;
        dashboardModel.metricsCollection = new RivalIQ.collections.MetricDefinitions(dashboardModel.metrics);
    };

    utils.getSortableProperties = function (source, objectType, options) {
        const properties = utils[`${objectType}SortableProperties`];
        if (!_.isFunction(properties)) {
            return properties;
        }

        options = _.extend(options || {}, {
            source: source
        });
        return properties(options);
    };

    utils.storySortableProperties = [
        'published_at',
        'media_type',
        'exits',
        'exit_rate',
        'full_view_rate',
        'impressions',
        'reach',
        'replies',
        'taps_forward',
        'taps_back',
        'completion_rate',
        'taps_forward_rate',
        'reach_rate',
        'swipes_forward',
        'shares',
        'follows',
        'profile_visits',
        'profile_activity_total',
        'profile_activity_bio_link_clicked',
        'profile_activity_not_bio_link_clicked'
    ];

    utils.storyDaySortableProperties = [
        'story_day_date',
        'stories_retention_rate',
        'max_reach',
        'max_reach_rate',
        'num_stories',
        'replies',
        'taps_forward',
        'taps_back',
        'story_impressions',
        'exits',
        'swipes_forward',
        'shares',
        'follows',
        'profile_visits',
        'profile_activity_total',
        'profile_activity_bio_link_clicked',
        'profile_activity_not_bio_link_clicked'
    ];

    const instagramSortableProperties = [
        'published_at',
        'reach',
        'media_type',
        'engagement_total',
        'engagement_rate_by_reach',
        'engagement_rate_by_impression',
        'reach_rate',
        'likes',
        'comments',
        'saves',
        'impressions',
        'video_views',
        'total_carousel_children',
        'num_photo_children',
        'num_video_children',
        'video_view_rate',
        'video_views_per_user',
        'link_clicks',
        'social_engagement_total',
        'social_engagement_rate_by_reach',
        'social_engagement_rate_by_impression',
        'shares',
        'follows',
        'profile_visits',
        'profile_activity_total',
        'profile_activity_bio_link_clicked',
        'profile_activity_not_bio_link_clicked'
    ];

    utils.postSortableProperties = function (options) {

        let properties = _.map(RivalIQ.data.metrics.forSourcePost(options.source), 'property');
        if (options.source === RivalIQ.enums.sources.INSTAGRAM_INSIGHTS) {
            const hasPaidEngagement = _.get(options, ['hasPaidEngagement'], false);
            const reducer = utils.instagramPaidEngagementPropertyReducer(hasPaidEngagement);
            properties = _.reduce(instagramSortableProperties, reducer, []);
        }

        properties = _.union(properties, ['published_at']);

        return properties;
    };

    function currency(dashboardModel, val, noAbbreviation) {
        const adAccount = _.head(dashboardModel.curation.activeFacebookAdAccounts);

        let adAccountCurrency = _.get(adAccount, ['currency']);
        // NOTE if we didn't find an `adAccount` then we'll pick out the
        // `currency` with the largest spend (see #20393)
        if (!adAccountCurrency) {
            let max = Number.MIN_VALUE;
            adAccountCurrency = _.reduce(val, function (memo, spend, currency) {
                if (spend > max) {
                    max = spend;
                    return currency;
                }
                return memo;
            }, null);
        }

        const formatterOptions = (noAbbreviation ? undefined : {
            abbreviate: true,
            decimals: 0
        });

        return RivalIQ.formatter.formatAmountAndCurrency({
            value: _.get(val, [adAccountCurrency]),
            currency: adAccountCurrency
        }, formatterOptions);
    }

    utils.currencyTemplateHelpers = function (dashboardModel) {
        return {
            currency: _.partial(currency, dashboardModel),
            promotedPostPopoverTemplate: Marionette.TemplateCache.get('#tableCellTooltip')
        };
    };

    utils.getOrderBy = function (propable) {
        const objectType = propable.getProp('objectType');
        const sortableProperties = utils.getSortableProperties(propable.getProp('source'), objectType, {
            hasPaidEngagement: utils.hasInstagramPaidEngagement(propable)
        });

        // NOTE default to the first sortable property for the type
        let property = _.head(sortableProperties);

        const orderBy = propable.getProp('orderBy');
        if (_.isString(orderBy)) {
            property = orderBy;
        } else if (_.isFinite(orderBy)) {
            const metricsCollection = _.get(propable, ['dashboardModel', 'metricsCollection'], propable.metricsCollection);
            const metric = metricsCollection.at(orderBy);
            // NOTE it is possible that `metric` will not exist so we must be
            // ever vigilant...
            if (metric) {
                property = _.get(metric.toType(), 'property');
            }
        }

        return property;
    };

    utils.allowPageBreaksInFocus = function () {
        const me = this;
        return me.isFocus();
    };

    const metricGroupTypeToMetricName = {
        page_reach_age_gender: 'page_impressions_by_age_gender_unique'
    };

    const dataWarnings = {
        UNKNOWN: 0,
        INSUFFICIENT_DATA_DAYS: 1,
        LOW_COUNT: 2
    };

    const FACEBOOK_DEPRECATED_WIDGET_IDS = [`fb_insights_page_fans_locations`, `fb_insights_page_impressions_and_reach_locations`, `fb_insights_page_reach_gender`, `fb_insights_page_reach_age`];

    function checkForDeprecatedMetricDescription(widgetId) {
        if (_.includes(FACEBOOK_DEPRECATED_WIDGET_IDS, widgetId)) {
            return RivalIQ.strings.facebook_deprecated_2024_09;
        }
    }

    utils.getNotEnoughDataDescription = function (dashboardModel, dataWarning, timePeriod) {
        const type = dashboardModel.metricGroupType;
        const widgetId = dashboardModel.curation?.widgetId;

        const metricName = metricGroupTypeToMetricName[type];

        const mainPeriodDuration = moment.utc(timePeriod.mainPeriodEnd).diff(moment.utc(timePeriod.mainPeriodStart), 'days') + 1;

        const deprecatedMetricDescription = checkForDeprecatedMetricDescription(widgetId);
        if (deprecatedMetricDescription) {
            return deprecatedMetricDescription;
        }

        if (dataWarning && metricName) {
            if (dataWarning[metricName]) {
                const warningType = _.isObject(dataWarning[metricName]) ? dataWarning[metricName].type : dataWarning[metricName];
                if (warningType === dataWarnings.INSUFFICIENT_DATA_DAYS) {
                    return RivalIQ.str('facebook_insights_age_gender_not_enough_data_page_reach_description', dataWarning[metricName].count, mainPeriodDuration);
                } else if (warningType === dataWarnings.LOW_COUNT) {
                    return RivalIQ.strings.facebook_insights_age_gender_missing_data_page_reach_description;
                }
            } else if (type === 'impressions') {
                return RivalIQ.strings.facebook_insights_age_gender_not_enough_data_description;
            }
        }

        return null;
    };


}, window.s);
